import { connect } from 'react-redux'
import { getIdentityActiveProTrackWithLevelName } from 'store/entities/identity/selectors'
import { getAssetsUrl } from 'helpers/getAssetsUrl'

import ActivityStatsEmpty from './ActivityStatsEmpty'

const mapStateToProps = state => ({
  imagePath: getAssetsUrl('users/6d7c804d-0e26-4409-8850-198ec64a6d3f.png'),
  proTrackWithLevelName: getIdentityActiveProTrackWithLevelName(state),
})

export default connect(mapStateToProps)(ActivityStatsEmpty)
